export type EditKeysType = 'MESSAGE' | 'COUNTRY';

export const EDIT_KEYS = ['MESSAGE', 'COUNTRY'];
